import * as SearchUrlParameters from '../models/SearchUrlParameters';
import {
    ARRIVAL,
    DEPARTURE,
    FILTER,
    KEYWORDS,
    MAX_BATHROOMS,
    MAX_BEDROOMS,
    MAX_NIGHTLY_PRICE,
    MAX_SLEEPS,
    MIN_BATHROOMS,
    MIN_BEDROOMS,
    MIN_NIGHTLY_PRICE,
    MIN_SLEEPS,
    PAGE
} from './SearchUrlParameters';

// @flow
// Region Parameter can be brand-specific.
// Though we are greedy in determining regionId value and do not consider site name.
// See https://github.homeawaycorp.com/geo/gbs/blob/752486c57169c43721a633321591e93d3d419423/gbs-url/src/main/java/com/homeaway/geo/gbs/url/GbsUrlUtils.java#L31
// and https://github.homeawaycorp.com/geo/gbs/blob/752486c57169c43721a633321591e93d3d419423/gbs-url/src/main/java/com/homeaway/geo/gbs/url/GbsUrlService.java#L98
export const REGION_COLON_PARAMETER_VARIANTS: string[] = [
    /* default */
    'region',
    /* vrbo? */
    'regions',
    /* homeaway_de */
    'regionen',
    /* BR */
    'regiao',
    /* IT */
    'regione',
    /* NL */
    'regio',
    /* FI */
    'Matkakohteesi'
];

export const LEGACY_PATH_PARAM_PROPERTY_TYPES: string[] = [
    'property type',
    'unterkunftsart'
];

export const LEGACY_PATH_PARAM_LOCATION_TYPES: string[] = [
    'location type',
    'ortstyp'
];

export const LEGACY_PATH_PARAM_FEATURE_TYPES: string[] = [
    'features',
    'ausstattung'
];

export const BOUNDING_BOX_REGEX: RegExp = /@(-?\d+\.?\d+,){4}(\d{1,2})z/g;

export const LANDING_PAGE_URL_PATTERN: RegExp = /\/(.+)\/r(\d+)/;

export const LANDING_PAGE_URL_PREFIXES: string[] = [
    /* abritel, canada french, expedia fr */
    '/vacances',
    /* alugueTemporada */
    '/ferias',
    /* australia */
    '/holiday-rentals',
    /* canada english*/
    '/cottage-rentals',
    /* denmark */
    '/ferie-bolig-lejlighed',
    /* FewoDirekt, expedia de */
    '/urlaub-ferienwohnung-ferienhaus',
    /* finland */
    '/loma-asunto',
    /* new zealand */
    '/holiday-accommodation',
    /* united kingdom */
    '/lettings',
    /* homelidays com (fr) */
    '/location-vacances',
    /* homelidays es */
    '/alquiler-vacacional',
    /* homelidays it */
    '/case-vacanze',
    /* italy, expedia it */
    '/case-vacanze-appartamenti',
    /* mexico */
    '/alquileres-vacaciones',
    /* netherlands */
    '/vakantie-vakantiehuis-vakantiewoning',
    /* norway */
    '/ferie-leilighet-feriehus',
    /* odhr */
    '/rentals',
    /* poland */
    '/apartamenty-wakacyjne',
    /* portugal */
    '/casas-apartamentos-ferias',
    /* spain */
    '/alquiler-vacaciones',
    /* sweden */
    '/semester-stugor-laegenhet',
    /* luxury */
    '/vacation-rentals',
    /* vr */
    '/browse',
    /* homeaway-gr */
    '/ενοικίαση-για-διακοπές',
    /* homeaway-at */
    '/ferienwohnung-ferienhaus-urlaub',
    /* abritel legacy */
    '/annonces',
    /* stayz */
    '/accommodation',
    /* bookabach */
    '/baches-and-holiday-homes'
];

export const SEARCH_URL_PARAMETERS = Object.keys(SearchUrlParameters)
    .filter((k) => k !== '__esModule')
    .map((k) => SearchUrlParameters[k]);

export const SLASH_PARAMETERS: string[] = [
    MIN_NIGHTLY_PRICE,
    MAX_NIGHTLY_PRICE,
    MIN_BEDROOMS,
    MAX_BEDROOMS,
    MIN_SLEEPS,
    MAX_SLEEPS,
    MIN_BATHROOMS,
    MAX_BATHROOMS,
    FILTER
];

export const COLON_PARAMETERS: string[] = [PAGE, KEYWORDS, ARRIVAL, DEPARTURE];
